'use strict';

var $           = require('js/sw-jquery/sw-jquery');
var TextSpinner = require('js/lib/views/TextSpinner');

module.exports = function ($fragment) {

  $fragment.swFindWithSelf(TextSpinner.prototype.swSelectors.ROOT).each(function () {

    var $el = $(this);

    new TextSpinner({
      el: $el
    });

  });

};
